import { API, getRequest, putRequest } from '@/api/api';
import type { UserDashboardSettings } from '@/utils/dashboard.types';

export async function fetchDashboardSettings(
  userId: string,
): Promise<UserDashboardSettings | null> {
  try {
    const { data } = await getRequest<UserDashboardSettings>(API.PEOPLE, `/${userId}/settings`);
    return data ?? null;
  } catch {
    return null;
  }
}

export async function saveDashboardSettings(
  userId: string,
  settings: UserDashboardSettings,
): Promise<UserDashboardSettings> {
  const { data } = await putRequest<UserDashboardSettings, UserDashboardSettings>(
    API.PEOPLE,
    `/${userId}/settings`,
    settings,
  );
  return data;
}
